import { SeatConfig } from '../types';
import { getAllSeatAssignments } from './db';

// 指定された席設定に基づいて、ランダムな席番号を生成
export async function getRandomSeat(config: SeatConfig): Promise<number> {
  const { totalSeats } = config;
  const existingAssignments = await getAllSeatAssignments();
  const assignedSeatNumbers = existingAssignments.map(a => a.seatNumber);
  
  // すべての席が埋まっている場合はエラー
  if (assignedSeatNumbers.length >= totalSeats) {
    throw new Error('All seats are already assigned');
  }
  
  // ランダムな席番号を生成（すでに割り当て済みの席は除外）
  let seatNumber: number;
  do {
    seatNumber = Math.floor(Math.random() * totalSeats) + 1;
  } while (assignedSeatNumbers.includes(seatNumber));
  
  return seatNumber;
}

// テーブル番号と席番号を計算（テーブルレイアウトの場合）
export function getTableAndSeatNumber(seatNumber: number, seatsPerTable: number): { tableNumber: number; seatAtTable: number } {
  const tableNumber = Math.ceil(seatNumber / seatsPerTable);
  const seatAtTable = ((seatNumber - 1) % seatsPerTable) + 1;
  
  return { tableNumber, seatAtTable };
} 